import { jsx as _jsx } from "react/jsx-runtime";
import { AppSignUpModalVariant, isFaireDirectVariant } from "@faire/retailer-visitor-shared/components/AppSignUp/AppSignUpModalVariant";
import { useFaireDirectBrand } from "@faire/retailer-visitor-shared/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
import { useSettingFaireDirectSignupModalRefresh } from "@faire/retailer-visitor-shared/settings/useSettingFaireDirectSignupModalRefresh";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web--source/common/localization/localize";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
export var Title = function(param) {
    var modalVariant = param.modalVariant, align = param.align;
    var settingFaireDirectSignupModalRefresh = useSettingFaireDirectSignupModalRefresh();
    return /*#__PURE__*/ _jsx(Typography, {
        variant: isFaireDirectVariant(modalVariant) && !settingFaireDirectSignupModalRefresh ? {
            mobileAndAbove: "pageHeaderSerifRegular",
            tabletAndAbove: "displaySSerifRegular"
        } : "displaySSerifRegular",
        align: align !== null && align !== void 0 ? align : "center",
        children: /*#__PURE__*/ _jsx(TitleText, {
            modalVariant: modalVariant
        })
    });
};
var TitleText = function(param) {
    var modalVariant = param.modalVariant;
    var faireDirectBrand = useFaireDirectBrand().faireDirectBrand;
    var brandName = faireDirectBrand === null || faireDirectBrand === void 0 ? void 0 : faireDirectBrand.name;
    var settingFaireDirectSignupModalRefresh = useSettingFaireDirectSignupModalRefresh();
    if (modalVariant === AppSignUpModalVariant.FAIRE_DIRECT) {
        if (settingFaireDirectSignupModalRefresh) {
            return brandName ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "Z3UErO",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Buy "
                    },
                    {
                        type: 1,
                        value: "brandCompanyName"
                    },
                    {
                        type: 0,
                        value: ", risk\u2011free"
                    }
                ],
                values: {
                    brandCompanyName: brandName
                }
            }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "TdMQvp",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Buy from this brand, risk\u2011free"
                    }
                ]
            });
        } else {
            return /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "2nuAPB",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Shop "
                    },
                    {
                        type: 1,
                        value: "brandName"
                    },
                    {
                        type: 0,
                        value: " online"
                    }
                ],
                values: DEPRECATED_backwardsCompatibleValues({
                    brandName: brandName
                })
            });
        }
    }
    return /*#__PURE__*/ _jsx(StrictLocalMsg, {
        id: "1U70mU",
        defaultMessage: [
            {
                type: 0,
                value: "Unlock wholesale pricing"
            }
        ]
    });
};
